import React from 'react';
import homeuser from "../assets/hs-image.png";
import wavylines from "../assets/decoration-1.png";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

const HomeSection = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "personal",
      title: "Personal Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  const handleNavigation = () => {
    navigate("/how-it-works");
  };

  const handleScrollDownClick = () => {
    window.scrollBy({
      top: 600, 
      behavior: 'smooth',
    });
  };

  return (
    <section className="hs-hero-section">
      <div className="hs-main-content">
        <div className="hs-content">
          {/* <p className="highlight-rate">“Thinking of applying for a loan?"</p>   */}
          {/* <p className='hs-offer-content'>
            <span>
              Confused about which Bank to apply, interest rates, and tenure?
            </span>
            <br />
            <span>Here’s the solution — Based on your profile,</span>
            <br />
            <span>
              Right Lender instantly finds the Best Bank/NBFC with the best
              offer for you.
            </span>
          </p> */}
          <p>“Get Instant Personal Loan up-to"</p>
          <h1>“₹10 LAKHS”</h1>
          <p className='hs-offer-content'>
            <span className="about-questions-icon">●</span>65+ Bank & NBFC
            partners Flexible Tenure up to 84 Months*
          <p className='hs-offer-content'>
            <span className="about-questions-icon">●</span>InterestRate Starts @10.25%*
            <span className="about-questions-icon">●</span>10-Minute Approval*
            <span className="about-questions-icon">●</span>Quick Disbursal
          </p>
          </p>
          <div className="hs-buttons">
            {plans.map((plan, index) => (
              <button
                className="hs-primary-btn"
                onClick={() => handleApplyClick(plan.loanType)}
                key={index}
              >
                <span>Proceed</span>
              </button>
            ))}
            <h5 className='how-its-work' onClick={handleNavigation}>How It Works?</h5>
          </div>
          {/* <p className='hs-offer-content'>“The right people choose us — because we get them approved.”</p> */}
        </div>
        <div className="hs-illustration">
          <img
            src={homeuser}
            alt="Illustration"
            className="hs-homeuser-image"
          />
        </div>
      </div>
      <p className='hs-home-content'>“The right people choose us — because we get them approved.”</p>
      <div className="hs-scroll-down" onClick={handleScrollDownClick}>
        <div className="scroll-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="#4a4a4a"
            strokeWidth="1"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="#D4D4D4"
              strokeWidth="1"
            ></circle>
            <line
              x1="12"
              y1="8"
              x2="12"
              y2="16"
              stroke="#4a4a4a"
              strokeWidth="1"
            ></line>
            <polyline
              points="8 12 12 16 16 12"
              stroke="#4a4a4a"
              strokeWidth="1"
            ></polyline>
          </svg>
        </div>
        <span>Scroll Down</span>
      </div>
    </section>
  );
};

export default HomeSection;